import React, { useEffect } from 'react'
// import profile from '../assets/images/profile.png';
import resume from '../assets/images/MOHD_TAUSIF_RESUME.pdf';
import PrimaryButton from './PrimaryButton';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from '../Styles/hoverText.module.css'


const AboutSectionStyled = styled.div`
    margin-top: 3.4rem;
    display: flex;
    @media screen and (max-width:1000px){
        flex-direction: column-reverse;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    @media screen and (max-width:600px){
        overflow: hidden;
    }
    .left-content{
        width: 100%;
    img{
        width: 85%;
        margin-left: 66px;
        object-fit: cover;
        }
    }
    .right-content{
        width: 100%;
        h4{
            font-size: 2rem;
            color: var(--white-color);
        span{
            font-size: 2rem;
        }
    }
    .paragraph{
        padding: 1rem 0;
        text-align: justify;
    }
    .about-info{
        display: flex;
        padding-bottom: 1.4rem;
        .info-title{
            padding-right: 3rem;
            p{
                font-weight: 600;
            }
        }
        @media screen and (max-width:600px){
            .info-title{
                padding-right: 0.6rem;
            }
            p{
                font-size: 1rem;
            }
        }
        .info-title, .info{
            p{
                padding: .32rem 0;
            }
        }
    }   
}
`;

const AboutSection = () => {

    useEffect(() => {
        AOS.init({ duration: 2000, })
    }, [])

    const email = "mohammadtausif14@gmail.com"
    const start_email = email.slice(0, 14)
    const end_email = email.slice(14)
    const new_email = <label>{start_email}<br />&nbsp;{end_email}</label>
    const screen_width = window.screen.availWidth

    return (
        <AboutSectionStyled>
            <div className="right-content" data-aos="fade-right">
                <h4>I'm <span>Mohd Tausif</span></h4>
                <p className="paragraph">
                    I have <strong style={{ color: '#007BFF' }}>around 4 years</strong> of experience in building user-friendly web applications using React.js and proficient in modern
                    JavaScript. I'm also skilled at solving challenging UI issues and providing scalable and efficient solutions.
                    {/* I'm a proficient <strong>Full-Stack Web Developer</strong> with a huge interest in JavaScript. I built several projects in web development using MERN-STACK. */}
                    I completed a diploma in Computer Science and Engineering from Government Polytechnic Shahjahanpur in 2019. I also completed a Full-Stack Web Development course at <a href="https://masaischool.com" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF' }}>@MasaiSchool.</a> and now I'm working as an <strong>Associate Full-Stack Web Developer</strong> at <a href="https://perennialsys.com" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF' }}>@PerennialSystems.</a>
                </p>
                <div className="about-info">
                    <div className="info-title">
                        <p>Full Name</p>
                        <p>Email</p>
                        {screen_width < 500 ? <br /> : ''}
                        <p>Mobile</p>
                        <p>Languages</p>
                        <p>Location</p>
                        <p>Nationality</p>
                    </div>
                    <div className="info">
                        <p>: Mohd Tausif</p>
                        <p className={styles.tooltip}>:<a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox" target="_blank" rel="noopener noreferrer">&nbsp;{screen_width < 500 ? new_email : email}</a>
                            <span className={styles.tooltipText}>click to send mail</span>
                        </p>
                        <p className={styles.tooltip}>: <a href="tel:+919140708447">+919140708447</a>
                            <span className={styles.tooltipText}>click to make call</span>
                        </p>
                        <p>: Hindi, English, Urdu </p>
                        <p>: Budaun, Uttar Pradesh</p>
                        <p>: Indian </p>
                    </div>
                </div>
                <a href={resume} target="_blank" rel="noopener noreferrer"><PrimaryButton title={'Resume'} /></a>
                {/* <PrimaryButton title={<a href={resume} target="_blank" rel="noopener noreferrer">Download Resume</a>} /> */}
            </div>
            {/* <div className="left-content" data-aos="fade-left">
                <img src={profile} alt="" />
            </div> */}
        </AboutSectionStyled>
    )
}

export default AboutSection